import { CityForm } from '../../components';

const CreationPage = () => {
  return <CityForm />;
};

export default CreationPage;
